/**
 * Quicklinks fahren beim Laden ein, Leere Quicklinks werden entfernt
 * Touch-Unterstützung integriert
 *
 * Event: window.load
 *
 * @param {string} quicklinksSelector
 * @return {undefined}
 */
function nc_initQuicklinks(quicklinksSelector) {
    $(document).ready(function() {
        nc_quicklinks(quicklinksSelector);
    });
}


/**
 * @see nc_initQuicklinks
 */
function nc_quicklinks(quicklinksSelector) {
    if (!$(quicklinksSelector).length) return;

    // Leere Quicklinks entfernen
    $('body:not(#editMode) '+quicklinksSelector + '>li .quicklinks_box_content, '+
        'body:not(#editMode) '+quicklinksSelector + '>li .quicklinks_icons_content').each(function() {
        if ($(this).text().trim() === '') {
            $(this).parent().remove();
        }
    });

    // Quicklinks Leiste beim Laden einfahren lassen
    $(quicklinksSelector).addClass('show');


    // Touch Hover
    $(quicklinksSelector + '>li').each(function () {
        $(this).on("touchstart", function (e) {
            if (!$(this).hasClass('hover')) {
                $(this).addClass('hover');
                e.preventDefault();
                $(this).siblings().each(function () {
                    $(this).removeClass('hover');
                });
                return false;
            }
            return true;
        });
    });


    // Wieder entfernen, wenn man woanders hin klickt
    $(document).on("touchstart", function (e) {
        if ($(e.target).is(quicklinksSelector + '>li') === false) {
            $(quicklinksSelector + '>li').each(function () {
                $(this).removeClass('hover');
            });
        }
    });
}